"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconToolkitFilled = function IconToolkitFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.63 25L33.51 20.12C34.1875 20.2568 34.8901 20.1956 35.5338 19.9438C36.1775 19.692 36.7351 19.2602 37.14 18.7L41.85 12.33C41.9648 12.1583 42.0148 11.9513 41.991 11.7461C41.9672 11.5409 41.8711 11.3509 41.72 11.21L38.77 8.21002C38.6281 8.06066 38.4382 7.96584 38.2336 7.94209C38.0289 7.91833 37.8224 7.96715 37.65 8.08002L31.28 12.79C30.7198 13.1949 30.288 13.7525 30.0362 14.3962C29.7844 15.0399 29.7232 15.7425 29.86 16.42L25 21.37L20.48 16.85C20.9499 15.6782 21.0655 14.3942 20.8125 13.1572C20.5596 11.9202 19.9491 10.7847 19.0569 9.89144C18.1647 8.99814 17.0299 8.38634 15.7932 8.1319C14.5566 7.87745 13.2724 7.99154 12.1 8.46002L16.57 13L12.93 16.65L8.46 12.14C8.01442 13.3037 7.91544 14.5715 8.17501 15.7902C8.43457 17.0089 9.04158 18.1263 9.92266 19.0074C10.8037 19.8884 11.9212 20.4955 13.1399 20.755C14.3586 21.0146 15.6264 20.9156 16.79 20.47L20.37 24.05C19.8571 24.2767 19.3921 24.5991 19 25L9.27 34.63C8.86417 35.0362 8.54318 35.5191 8.32571 36.0505C8.10825 36.5819 7.99866 37.1513 8.00331 37.7255C8.00796 38.2997 8.12677 38.8672 8.35282 39.395C8.57886 39.9228 8.90764 40.4004 9.32 40.8C10.1342 41.5669 11.2136 41.989 12.3321 41.9778C13.4505 41.9666 14.5213 41.523 15.32 40.74L25 31.05C25.4242 30.6477 25.7641 30.165 26 29.63L37.57 41.24C38.0527 41.7227 38.7074 41.9939 39.39 41.9939C40.0726 41.9939 40.7273 41.7227 41.21 41.24C41.6927 40.7573 41.9639 40.1027 41.9639 39.42C41.9639 38.7374 41.6927 38.0827 41.21 37.6L28.63 25Z",
    fill: color
  }));
};

IconToolkitFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconToolkitFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconToolkitFilled;
exports.default = _default;